import { Context } from "chartjs-plugin-datalabels";
import { Paper, Table, Typography, Box, Stack, Select, MenuItem, FormControl } from "@mui/material";
import { experimentalStyled as styled } from "@mui/material/styles";
import { Doughnut } from "react-chartjs-2";
import { TextQuestion } from "../../models/Question";
import { SentimentBar } from "../ui";
import { useState } from "react";
import "./mui-select-menu-fix.css";

// import { ProgressBar } from "react-bootstrap"; // DELETE THIS
// import { MyMatrix, MyProgressBar } from '../../../../helpers/funtionsUtils/funtionsUtils';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: '16px',
  paddingLeft: '30px',
  marginBottom: theme.spacing(3),
  color: theme.palette.text.primary,
  width: "100%",
  height: "auto",
  border: '1px solid #e0e0e0'
}));

interface Props {
  index: number;
  question: TextQuestion;
}

function calculateChoiceValues(question: any): number[] {
  let choiceValues = [0, 0, 0];
  console.log("question: ", question);
  if (question !== undefined) {
    for (const x of question.sentimentScores) {
      if (x > 0.33) {
        if (x > 0.66) choiceValues[2]++;
        else choiceValues[1]++;
      } else choiceValues[0]++;
    }
  }
  console.log("choise: ", choiceValues);
  return choiceValues;
}

export function Type2QuestionChart({ index, question }: Props): JSX.Element {
  const [sentimentFilter, setSentimentFilter] = useState("all");

  /*
  const doughnutData = {
    labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
    datasets: [
      {
        label: "# of Votes",
        data: [12, 19, 3, 5, 2, 3],
        borderWidth: 1,
      },
    ],
  };

  const doughnutOptions = {
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };
  */

  const doughnutData = {
    labels: ["negative", "neutral", "positive"],
    datasets: [
      {
        label: "",
        data: calculateChoiceValues(question),
        borderWidth: 1,
        backgroundColor: ["#FB5523", "#FDD835", "#6DAE43"],
        /*
        plugins:{
          datalabels: {
          formatter: function(value : any, context : any) {
              return Math.round((value/calculateChoiceValues(question).reduce((a:any, b:any) => a + b, 0))*100) + '%';
          }
        }
        */
      },
    ],
  };

  const doughnutOptions = {
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        color: "#111",
        textAlign: "center",
        font: {
          lineHeight: 1.6,
        },
        formatter: (value: number, ctx: Context) => {
          if (ctx.chart.data.labels && value > 0) {
            return (
              ctx.chart.data.labels[ctx.dataIndex] +
              "\n" +
              ((value / question.answers.length) * 100).toFixed(2) +
              "%"
            );
          } else if (value === 0) {
            return "";
          }
        },
      },
    },
  };

  return (
    <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2}>
      <Box sx={{ width: { xs: '100%', lg: 'calc(75% - 8px)' } }}>
        <Item sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '8px' }}>
          <Box sx={{ 
            display: 'flex', 
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            marginBottom: '16px',
            gap: { xs: '12px', sm: '0px' }
          }}>
            <h3
              style={{
                fontSize: "18px",
                fontWeight: "500",
                color: "#4E4E4E",
                fontFamily: "'IBM Plex Sans', sans-serif",
                margin: 0
              }}
            >
              {index}. {question.title}
            </h3>
            <FormControl size="small" sx={{ minWidth: 150, maxWidth: 220, width: 'auto' }}>
              <Select
                value={sentimentFilter}
                onChange={(e) => setSentimentFilter(e.target.value)}
                variant="outlined"
                sx={{
                  fontSize: '14px',
                  fontFamily: 'IBM Plex Sans',
                  backgroundColor: 'white',
                  border: '1px solid #e0e0e0',
                  borderRadius: '4px',
                  minWidth: 150,
                  maxWidth: 220,
                  width: '100%',
                  '& fieldset': {
                    border: 'none',
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxWidth: 220,
                      minWidth: 150,
                      width: '100%',
                    },
                    style: {
                      maxWidth: 220,
                      minWidth: 150,
                      width: '100%',
                    }
                  }
                }}
              >
                <MenuItem value="all">All comments</MenuItem>
                <MenuItem value="positive">Positive</MenuItem>
                <MenuItem value="neutral">Neutral</MenuItem>
                <MenuItem value="negative">Negative</MenuItem>
              </Select>
            </FormControl>
          </Box>
            <Box sx={{ overflowX: 'auto', width: '100%', WebkitOverflowScrolling: 'touch' }}>
            <Table
              sx={{
                minWidth: { xs: '280px', sm: '500px' },
                '& thead th': {
                  borderBottom: '2px solid #1A237E',
                  color: '#1A237E',
                  fontSize: { xs: '12px', sm: '13px', md: '14px' },
                  fontWeight: '600',
                  fontFamily: 'IBM Plex Sans',
                  padding: '12px 16px 12px 0px',
                  paddingBottom: '12px',
                  backgroundColor: '#FFFFFF'
                },
                '& tbody tr:nth-of-type(even)': {
                  backgroundColor: '#f4f5ff'
                },
                '& tbody tr:nth-of-type(odd)': {
                  backgroundColor: '#FFFFFF'
                },
                '& tbody td': {
                  borderBottom: '1px solid #e8eaed',
                  fontSize: { xs: '12px', sm: '13px', md: '14px' },
                  fontFamily: 'IBM Plex Sans',
                  padding: '12px 16px 12px 0px',
                  color: '#4E4E4E'
                },
                '& tbody tr:last-child td': {
                  borderBottom: 'none'
                },
                '& thead th:first-of-type, & tbody td:first-of-type': {
                  paddingLeft: '8px'
                },
                '& thead th:last-of-type, & tbody td:last-of-type': {
                  paddingRight: '0px'
                }
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: '85%' }}>Answers</th>
                  <th style={{ width: '15%', textAlign: 'center' }}>Sentiment</th>
                </tr>
              </thead>
              <tbody>
                {question.answers.map((answer, index) => {
                  const sentimentScore = question.sentimentScores[index];
                  
                  // Filtrar por sentimiento
                  let sentimentType = "neutral";
                  if (sentimentScore > 0.66) sentimentType = "positive";
                  else if (sentimentScore <= 0.33) sentimentType = "negative";
                  
                  if (sentimentFilter !== "all" && sentimentFilter !== sentimentType) {
                    return null;
                  }
                  
                  return (
                    <tr key={index}>
                      <td>{answer}</td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <SentimentBar score={sentimentScore} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            </Box>
          </Item>
        </Box>
        <Box sx={{ width: { xs: '100%', lg: 'calc(25% - 8px)' } }}>
          <Item sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '8px', padding: '20px !important' }}>
            <Typography
              fontSize={"16px"}
              fontFamily={"IBM Plex Sans"}
              fontWeight={"600"}
              color="#1A237E"
              marginBottom="4px"
            >
              Satisfaction
            </Typography>
            <Typography
              fontSize={"13px"}
              fontFamily={"IBM Plex Sans"}
              fontWeight={"400"}
              color="#4E4E4E"
              marginBottom="24px"
            >
              Team feelings
            </Typography>
            <Box sx={{ 
              maxWidth: { xs: '100%', sm: '280px', lg: '100%' },
              margin: '0 auto'
            }}>
              <Doughnut
                // @ts-ignore
                options={doughnutOptions}
                data={doughnutData}
              />
            </Box>
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '30px',
              marginTop: '30px'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <Box sx={{ width: '24px', height: '8px', backgroundColor: '#FB5523', borderRadius: '2px' }} />
                <Typography fontSize="11px" fontFamily="IBM Plex Sans" color="#4E4E4E">Negative</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <Box sx={{ width: '24px', height: '8px', backgroundColor: '#FDD835', borderRadius: '2px' }} />
                <Typography fontSize="11px" fontFamily="IBM Plex Sans" color="#4E4E4E">Neutral</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <Box sx={{ width: '24px', height: '8px', backgroundColor: '#6DAE43', borderRadius: '2px' }} />
                <Typography fontSize="11px" fontFamily="IBM Plex Sans" color="#4E4E4E">Positive</Typography>
              </Box>
            </Box>
          </Item>
        </Box>
      </Stack>
  );
}

